import React from 'react'

const Footer = () => {
  return (
    <>
    <div className="footer-container">
    <p className="copyright">Copyright &copy; <script>document.write(new Date().getFullYear());</script>anonimusic</p>
    </div>
    </>
  )
}

export default Footer